import React from "react";
import CTAS from "../../assets/img/concierge/cta.jpeg";

const CTA = () => {
  return (
    <section className="px-6 pb-28">
      <div
        className="max-w-[1400px] mx-auto rounded-[40px] overflow-hidden relative"
        style={{
          backgroundImage:
            `linear-gradient(rgba(15,23,42,.70),rgba(15,23,42,.70)), url(${CTAS})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="max-w-[900px] mx-auto text-center py-32 px-6">
          <span
            className="uppercase tracking-[4px] text-[#B68A35] text-[14px]"
            style={{ fontFamily: "Poppins" }}
          >
            Personal Assistance In Spain
          </span>

          <h2
            className="text-white text-[60px] leading-tight mt-5"
            style={{ fontFamily: "Pochaevsk" }}
          >
            Need Personal Assistance In Spain?
          </h2>

          <p
            className="text-white/80 text-[17px] leading-8 mt-8"
            style={{ fontFamily: "Poppins" }}
          >
            From relocation and property management to luxury lifestyle
            services, our experienced team is here to provide tailored support
            and make your experience in Spain completely stress-free.
          </p>

          <div className="flex flex-wrap justify-center gap-5 mt-12">
            <a
              href="/contact"
              className="bg-[#B68A35] text-white px-10 py-5 rounded-full text-[16px] font-medium transition duration-300 hover:bg-[#9f782f]"
              style={{ fontFamily: "Poppins" }}
            >
              Schedule a Consultation
            </a>

            <a
              href="/concierge"
              className="border border-white text-white px-10 py-5 rounded-full text-[16px] font-medium transition duration-300 hover:bg-white hover:text-[#0F172A]"
              style={{ fontFamily: "Poppins" }}
            >
              Explore Services
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;